import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'userCategory',
    serviceName: 'unitadmin',
    query: gql`
      query userCategory($ids: [String]) {
        userCategory(ids: $ids) {
          data {
            id
            title
            parent {
              title
            }
          }
        }
      }
    `,
  },
};

export default schema;
